import React from 'react';
import { Button, Divider, Grid, Paper, Typography } from '@esgian/esgianui';
import { OXELogoIcon } from '@components/Icons';
import { useAuth } from 'react-oidc-context';
import { MOCK } from '@auth/userManager';

function LoginPage() {
  const auth = useAuth();

  const handleSignIn = () => {
    if (!MOCK) {
      auth.signinRedirect();
    }
  };

  return (
    <Grid
      container
      spacing={1}
      justifyContent={'center'}
      sx={{ minWidth: '100vw', minHeight: 'calc(100vh - 64px - 80px - 2em)' }}>
      <Grid item md={6} sm={10} xs={12} alignSelf={'center'}>
        <Paper variant={'outlined'} sx={{ p: 2 }}>
          <Grid container spacing={2} direction={'column'} alignItems={'center'}>
            <Grid item xs={12}>
              <OXELogoIcon id1={'logoa'} id2={'logob'} height={62} width={200} />
            </Grid>
            <Grid item xs={12}>
              <Typography variant={'h5'} id={'login-header'}>
                Sign In
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant={'body2'} id={'sub-header'}>
                Please sign in with your OceanX Energy account to continue
              </Typography>
            </Grid>
            <Divider />
            <Grid item container justifyContent={'center'}>
              <Grid item xs={8}>
                <Button
                  id={'login-button'}
                  fullWidth
                  variant={'contained'}
                  onClick={handleSignIn}>
                  Sign in with Microsoft
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
}

LoginPage.propTypes = {};
LoginPage.defaultProps = {};

export default LoginPage;
